module.exports = __webpack_public_path__ + "media/images/proof_links/twitter-9f5a6fdcd95f46be6c9df1d19b752792.svg";